export default __webpack_public_path__ + "static/media/slide_04.b0af86af.png";